import { BMText } from "@traveloka/district-bloom";
import { escapeRegExp } from "lodash";
import { ComponentProps } from "react";

type Props = {
  keyword: string;
  searchedText: string;
  defaultTextProps?: ComponentProps<typeof BMText>;
  highlightTextProps?: ComponentProps<typeof BMText>;
};
/**
 * HighlightText component to highlight specific keywords in a given text.
 * It splits the searchedText by the keyword and wraps the keyword with BMText
 * to apply specific styles.
 *
 * @param {Props} props - The properties for the HighlightText component.
 * @returns {JSX.Element} The rendered HighlightText component.
 */
export default function HighlightText({
  keyword,
  searchedText,
  defaultTextProps,
  highlightTextProps,
}: Props) {
  if (!keyword) {
    return <BMText {...defaultTextProps}>{searchedText}</BMText>;
  }

  const regex = new RegExp(`(${escapeRegExp(keyword)})`, "gi");

  return (
    <BMText {...defaultTextProps}>
      {searchedText.split(regex).map((part, index) =>
        regex.test(part) ? (
          <BMText key={index} {...highlightTextProps}>
            {part}
          </BMText>
        ) : (
          part
        )
      )}
    </BMText>
  );
}
